@if (loading$ | async) {
  <div class="page-loader">
    <p-progressSpinner
      ariaLabel="loading"
      strokeWidth="4"
    />
  </div>
}

@if(!initializing) {
  <router-outlet></router-outlet>
}

<p-toast
  position="top-right"
></p-toast>
